/**
 * @deprecated Use @faire/typescript/delay instead
 */

export const theFuture = (millisecondsInTheFuture: number = 0) =>
  new Promise((resolve: any) => setTimeout(resolve, millisecondsInTheFuture));
